import React from 'react';
import { createRoot } from 'react-dom/client';

import { DemarchePageSelector } from '../main-app/components/DemarchesPermis/components/DemarchePageSelector';
import { DemarcheSituationOption } from '../main-app/components/DemarchesPermis/types';

const parse = <T, >(value: string | null, fallback: T): T => {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value) as T;
  } catch (error) {
    return fallback;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-demarche-page-selector');

  if (!node) {
    return;
  }

  const slug = node.getAttribute('data-slug') || '';
  const tunnelUrl = node.getAttribute('data-tunnel-url') || '';
  const options = parse<DemarcheSituationOption[]>(node.getAttribute('data-options'), []);
  const redirects = parse<Record<string, string>>(node.getAttribute('data-redirects'), {});

  if (!slug || !options.length) {
    return;
  }

  const root = createRoot(node);

  root.render(
    <DemarchePageSelector
      slug={slug}
      heading={node.getAttribute('data-heading') || ''}
      subtitle={node.getAttribute('data-subtitle') || ''}
      ctaLabel={node.getAttribute('data-cta-label') || 'Continuer'}
      options={options}
      redirects={redirects}
      tunnelUrl={tunnelUrl}
    />,
  );
});
